$(document).ready(function() {
    $('a.logo').click(function( event ){
        event.preventDefault();
        $.fn.fullpage.setAllowScrolling(true, 'all');
        $.fn.fullpage.moveTo(1, 0);

    });
    $(".jsLink").click(function(){
         window.location=$(this).find("a").attr("href");
         return false;
    });

    $(".modal .closeModal").click(function(){
        $('.modal').removeClass('active');
    });
    $(".modalbtn").click(function(){
        $('.modal').addClass('active');
    });
});

$(document).ready(function() {
    $(".service-nav a").click(function(){
        $(".service-nav a").removeClass('active');
        $(this).addClass('active');

        $( ".service > div").addClass('close');
        $( ".service > div:nth-child("+$(this).attr('data-i')+")" ).removeClass('close');
    });

	$('#fullpage').fullpage({
		//options here
        cards: true,
		autoScrolling:true,
		scrollHorizontally: false,
        fadingEffect: false,
        loopBottom: false,
	    loopTop: false,
        slidesNavigation: false,
        slidesNavPosition: 'bottom',
        touchSensitivity: 40,
        scrollingSpeed: 1200,

        //licenseKey: 'YWx2YXJvdHJpZ28uY29tX0FXWVpISnZjRVZtWm1WamRBPT1mR3Q',
        afterRender: function(){
            $('video').each(function(index){
                $(this).get(0).pause();
            });

            $('#fullpage .section :first').find('video').each(function() {
                $(this).get(0).play();
            });

	    },
        onLeave: function(origin, destination, direction){
    		var leavingSection = this;

            //console.log($(destination.item).html());
            $(origin.item).find('video').each(function() {
                $(this).get(0).pause();
            });
            $(destination.item).find('video').each(function() {
                $(this).get(0).play();
            });
    	},
	});



	//methods
	//$.fn.fullpage.setAllowScrolling(true);
});
